import { getDistance } from 'geolib'
import { throttle } from 'lodash-es'

export const getCurrentLocation = async () => {
  if (!('geolocation' in navigator)) {
    throw new Error('No geolocation support in this browser')
  }

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (location) => resolve(location.coords),
      (err) => reject(err),
      {
        enableHighAccuracy: true,
      }
    )
  })
}

const getCurrentLocationThrottled = throttle(getCurrentLocation, 10000)

export const getDistanceFromPoint = async ({ longitude, latitude }) => {
  const currentLocation = await getCurrentLocationThrottled()

  return getDistance(
    { longitude, latitude },
    {
      longitude: currentLocation.longitude,
      latitude: currentLocation.latitude,
    }
  )
}
